import { createStore, Store } from "vuex";
import onBoardingModule, { OnBoardingState } from "./modules/OnBoardingModule";


export interface RootState {
  onBoarding: OnBoardingState
}

const store: Store<RootState> = createStore({
  modules: {
    onBoarding: onBoardingModule
  }
})

store.subscribe(async (mutation, state) => {
  if (mutation.type === "onBoarding/setPrice") {

  }
})

export default store;
